/*
This project uses iconify api for React. Browse more icon options at:
https://icon-sets.iconify.design
*/

// -->  Graphic Icons
export const LEAF = `el:leaf`;
export const MOWER = `mdi:mower-bag`;
export const PHONE = `carbon:phone-voice-filled`;
export const MONEY = `bxs:dollar-circle`;

// -->  Layout Icons
export const ARROW_RIGHT = `bi:arrow-right-circle-fill`;
export const CARROT_DOWN = `ant-design:caret-down-outlined`;
export const LEFT_DISC = `ant-design:left-circle-filled`;
export const RIGHT_DISC = `ant-design:right-circle-filled`;

export const STAR_FILLED = `bxs:star`;
export const STAR_HALF = `bxs:star-half`;
export const STAR_EMPTY = `bx:star`;

// --> Social Media Icons
export const YELP = `cib:yelp`;
export const FACEBOOK = `entypo-social:facebook`;
export const INSTAGRAM = `akar-icons:instagram-fill`;
export const YOUTUBE = `akar-icons:youtube-fill`;
export const EMAIL = `clarity:email-solid`;
export const YANDEX = `la:yandex-international`;
export const WP = `ic:round-whatsapp`
